import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import getTheme from '@/theme/theme';
import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

import LayoutWrapper from './LayoutWrapper';

type IMainProps = {
  meta: ReactNode;
  children: ReactNode;
  LayoutWrapperContents?: LayoutWrapperContents;
};

export default function AppLayout(props: IMainProps) {
  return (
    <HelmetProvider>
      {props.meta}
      <ThemeProvider theme={getTheme()}>
        <LayoutWrapper LayoutWrapperContents={props.LayoutWrapperContents}>
          <CssBaseline />
          {props.children}
        </LayoutWrapper>
      </ThemeProvider>
    </HelmetProvider>
  );
}
